<template src="~common/StickyHeader.html" />

<script>
  import MixinAddToCart from './Mixins/MixinAddToCart'
  import { CalculateMobilePrice } from './Mixins/CustomOptionsMixins'

	export default {
    mixins: [MixinAddToCart],
		computed: {
      stickyName () {
        return 'device'
      },
      /**
       * If the user select the option mobile alone only the shipping is free
       *
       * If the user select any other option and the upFrontPrice is equal to zero the activation fees is equal to 5€
       * because the user can't continue if is cart contain zero €
       *
       * If the user select any other option and the upFrontPrice is greater than zero then the shipping and the activations fees are equal to zero €
      */
      stickyLittleText () {
        if (!this.currentProduct.device_plan_sku) return this.$t('Free shipping')

        if (this.currentProduct.instalment && this.currentProduct.instalment.final_price) {
          if (parseFloat(this.currentProduct.instalment.final_price) === 0) {
            return `${this.$t('Activation fees')} ${this.activationFees}`
          } else if (parseFloat(this.currentProduct.instalment.final_price) > 0){
            return this.$t('No shipping or activation fees')
          }
        } else {
          return this.$t('No shipping or activation fees')
        }
      },
      activationFees () {
        return this.currentProduct.plan.activation_fees + this.currentProduct.currency
      },
      mobilePrice () {
        let optionPrice = parseFloat(this.currentProduct.plan.price) + parseFloat(this.productInformations.prices[this.currentProduct.sku].price);
        if (parseFloat(this.currentProduct.plan.activation_fees) > 0 && optionPrice === 0) optionPrice = this.currentProduct.plan.activation_fees
        return CalculateMobilePrice({optionPrice: optionPrice, currency: this.currentProduct.currency, locale: this.productInformations.locale})
      }
    }
	}
</script>
